import {useEffect} from 'react';

import {useHttpClient} from 'hooks';

export default function useReservedHostnames(clusterType) {
  const {data, loading, cancel} = useHttpClient({
    url: `/api/${clusterType}/reserved-hostnames`,
    method: 'GET',
  });

  useEffect(() => {
    return () => {
      cancel('Request to /reserved-hostnames has been cancelled');
    };
  }, [cancel]);

  return {
    isLoading: loading,
    reservedHostnames: data && !loading ? data.hostnames : [],
    reservedFullyQualifiedDomainNames: data && !loading ? data.fqdns : [],
  };
}
